import { getApiBaseUrl } from "../data/authStorage";
import httpClient from "./httpClient";

const baseUrl = getApiBaseUrl();

export async function listTodos(params = {}) {
  try {
    const response = await httpClient.get(`${baseUrl}/organizations/todos`, { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function listTodoAssignees() {
  try {
    const response = await httpClient.get(`${baseUrl}/organizations/todos/assignees`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function createTodo(payload) {
  try {
    const response = await httpClient.post(`${baseUrl}/organizations/todos`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function addTodoAttachments(todoId, files = []) {
  try {
    const body = new FormData();
    files.forEach((file) => body.append("files", file));
    const response = await httpClient.post(
      `${baseUrl}/organizations/todos/${encodeURIComponent(todoId)}/attachments`,
      body,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function updateTodo(todoId, payload) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/todos/${todoId}`, payload);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function deleteTodo(todoId) {
  try {
    const response = await httpClient.delete(`${baseUrl}/organizations/todos/${encodeURIComponent(todoId)}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function completeTodo(todoId) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/todos/${todoId}/complete`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}

export async function confirmTodoCompletion(todoId) {
  try {
    const response = await httpClient.patch(`${baseUrl}/organizations/todos/${todoId}/confirm-completion`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
}
